import styled from "styled-components";
import { TableRowFlex } from "@8x8/oxygen-table";

const StyledTableRow = styled(TableRowFlex)`
  overflow: visible;
  background-color: #fff;

  &:hover {
    background-color: #f5f5f5;
  }

  &.invalid {
    background-color: #fff5f0;

    &:hover {
      background-color: #fff5f0;
    }
  }

  &.modified {
    background-color: #f0f8ff;

    &:hover {
      background-color: #f0f8ff;
    }
  }

  &.new {
    background-color: #f7fff7ff;

    &:hover {
      background-color: #f7fff7ff;
    }
  }
`;

export const StyledTableHeadRow = styled(StyledTableRow)`
  background-color: #fff;

  &:hover {
    background-color: #fff;
  }
`;

export default StyledTableRow;
